module.exports = __webpack_public_path__ + "img/idcard_back.99a712c4.png";